module.exports = __webpack_public_path__ + "img/icon-arrow.6ea59958.svg";